"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feedback = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _feedback_yes = _interopRequireDefault(require("../../assets/images/feedback_yes.svg"));
var _feedback_no = _interopRequireDefault(require("../../assets/images/feedback_no.svg"));
var _reactSvg = require("react-svg");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _context = require("../ConfigProvider/context");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Feedback = function Feedback(props) {
  var _clsx;
  var value = props.value,
    yesValue = props.yesValue,
    noValue = props.noValue;
  var _useState = (0, _react.useState)(value !== null && value !== void 0 ? value : undefined),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    feedbackValue = _useState2[0],
    setFeedbackValue = _useState2[1];
  var context = (0, _react.useContext)(_context.ConfigContext);
  var onFeedbackClick = function onFeedbackClick(value) {
    var _props$onFeedbackClic, _context$eventEmitter, _context$eventEmitter2;
    if (feedbackValue !== undefined) return;
    (_props$onFeedbackClic = props.onFeedbackClick) === null || _props$onFeedbackClic === void 0 ? void 0 : _props$onFeedbackClic.call(props, value);
    context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, 'feedback', {
      value: value
    });
    setFeedbackValue(value);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('feedback'), (_clsx = {}, (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)('feedback-yes__choosed'), feedbackValue !== undefined && feedbackValue === yesValue), (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)('feedback-no__choosed'), feedbackValue !== undefined && feedbackValue === noValue), _clsx))
  }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('feedback-no')),
    src: _feedback_no.default,
    onClick: function onClick() {
      return onFeedbackClick(noValue);
    }
  }), /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('feedback-yes')),
    src: _feedback_yes.default,
    onClick: function onClick() {
      return onFeedbackClick(yesValue);
    }
  }));
};
exports.Feedback = Feedback;